import { render } from "./Noti_partner.vue?vue&type=template&id=7878d946&scoped=true"
import script from "./Noti_partner.vue?vue&type=script&lang=js"
export * from "./Noti_partner.vue?vue&type=script&lang=js"

import "./Noti_partner.vue?vue&type=style&index=0&id=7878d946&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7878d946"]])

export default __exports__